export default __webpack_public_path__ + "static/media/NBC 5.6ead08e9.pdf";